var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "home-content wrapper"
  }, [_c('transition', {
    attrs: {
      "name": "fadeIn",
      "mode": "out-in"
    }
  }, [(_vm.contentData) ? _c('div', {
    key: _vm.dataReady,
    staticClass: "home-content__container"
  }, [_c('article-view', {
    attrs: {
      "content-data": _vm.contentData
    }
  }), _vm._v(" "), _c('footer-comp')], 1) : _c('div', {
    key: _vm.dataReady,
    staticClass: "loading-page"
  }, [_c('loader', {
    attrs: {
      "label": _vm.routeName
    }
  })], 1)])], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-65303e3c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/vue/components/content-type/Home.vue
// module id = /5kN
// module chunks = 1